import React, { memo, useEffect, useRef } from "react";
import { classNames, useTranslate } from "helpers";
import { ReactSVG } from "react-svg";
import { VehicleFireExtinguisherSummaryProps } from "./types";

const VehicleFireExtinguisherSummary: React.FC<
  VehicleFireExtinguisherSummaryProps
> = ({ vehicleInfo, stepCurrent }) => {
  const { t } = useTranslate();
  const thisStep = 4;

  const isActive = stepCurrent === thisStep;
  const isCompleted = stepCurrent > thisStep;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [isActive]);

  if (!isActive && !isCompleted)
    return null;

  return (
    <div
      ref={ref}
      className={classNames(
        `
        bg-white rounded-md border border-blue-100 shadow-xl
    w-[280px] h-[260px]
        flex-shrink-0
        snap-start
        transition-all duration-300
        cursor-pointer
        `,
        isActive
          ? "opacity-100 scale-100 ring-2 ring-blue-500"
          : "opacity-70 hover:opacity-100 "
      )}
    >
      <div className="p-3 flex justify-between items-center min-h-[52px]">
        <h3 className="text-sm font-semibold text-slate-800">
          {thisStep + 1}. Vatrogasni aparati
        </h3>

        {isCompleted && (
          <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
            <ReactSVG
              src="/media/icons/check.svg"
              className="w-4 h-4 fill-green-500 stroke-green-500"
            />
          </div>
        )}
      </div>

      <div className="border-t border-slate-200 pb-4 p-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Naziv:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.fireExtinguisherName ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Datum isteka:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.fireExtinguisherExpirationDate ?? "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Cijena:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.fireExtinguisherPrice != null ? `${vehicleInfo.fireExtinguisherPrice} €` : "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Težina:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.fireExtinguisherWeight != null ? `${vehicleInfo.fireExtinguisherWeight} kg` : "-"}
          </span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Serijski broj:</span>
          <span className="text-slate-700 font-medium">
            {vehicleInfo.fireExtinguisherSerialNumber ?? "-"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(VehicleFireExtinguisherSummary);
